export const CUSTOMER_RESTRICTION = {
  PREPAYMENT: 'prepayment',
  BLOCKED: 'blocked',
  BANNED: 'banned'
}

export const CL_CUSTOMER_STATUS = ['prospect', 'repeat', 'acquired']

export const GUEST_USER_EMAILS = [
  'vcp+guestde@shopviu.com',
  'vcp+guestat@shopviu.com',
  'vcp+guestch@shopviu.com'
]

export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
